<template>
  <div>
    <OverviewComponent
      icon="mdi-truck-delivery-outline"
      :headers="headers"
      :data="data"
      :loading="loading"
      :totalPages="totalPages"
      :totalItemCount="totalItemCount"
      deadlineKey="deliveryDate"
      @click="clickCard"
      @setHeader="setHeader"
      @fetchData="fetchData"
    >
      <!-- <template v-if="showTable" v-slot:item.orderId="{ item }">
        <td @click="goToOrder(item.orderId)">{{ item.orderId }}</td>
      </template> -->
      <template v-if="showTable" v-slot:item.orderId="{ item }">
        <a @click="goToOrder(item.orderId)">{{ item.orderId }}</a>
      </template>
      <template v-if="showTable" v-slot:item.status="{ item }">
        <v-chip
          v-if="item.status && item.status !== 'Ukjent'"
          class="mr-2"
          :color="item.allReceived ? 'success' : 'warning'"
          small
        >
          {{ item.allReceived ? "Mottatt" : item.status }}
        </v-chip>
      </template>
      <template v-slot:title="{ item }">
        #{{ item.orderId }} -
        {{
          $vuetify.breakpoint.smAndDown
            ? getTruncatedTitle(item.project)
            : item.project
        }}
        -
        {{ item.phase }}
      </template>
      <template v-slot:chips="{ item }">
        <div v-for="(chip, index) in getChips(item)" :key="index">
          <v-chip class="mr-2" :color="chip.color" small>
            {{ chip.title }}
          </v-chip>
        </div>
      </template>
      <template v-slot:underRight="{ item }">
        {{ item.contactPerson }}
      </template>
      <template v-slot:underLeft="{ item }">
        {{ item.contactName }}
      </template>

      <!-- filters -->
      <template v-slot:filter.status="{ head, isTable }">
        <v-select
          v-model="head.filterValues"
          :label="isTable ? '' : head.text"
          :items="statusItems"
          item-text="text"
          item-value="value"
          :class="{ 'mb-0': isTable }"
          clearable
          multiple
          dense
          :filled="isTable ? false : true"
          :outlined="isTable ? true : false"
          flat
          hide-details="auto"
        >
        </v-select>
      </template>

      <!-- <template v-if="!showAllActions" v-slot:filter.contactPerson="{ head, isTable }">
        <v-text-field
          v-if="!head.removeFilter"
          :label="isTable ? '' : head.text"
          :value="getContactPersonName"
          :disabled="head.disabled"
          dense
          filled
          flat
          hide-details="auto"
        >
        </v-text-field>
      </template> -->
      <template v-slot:filter.contactPerson="{ head, isTable }">
        <v-text-field
          v-if="!head.removeFilter && !showAllActions"
          :label="isTable ? '' : head.text"
          :value="getContactPersonName"
          disabled
          dense
          :outlined="isTable"
          :filled="!isTable"
          flat
          :class="{ 'mb-0': isTable }"
          hide-details="auto"
        >
        </v-text-field>
        <v-autocomplete
          v-else
          v-model="head.filterValues"
          :items="filterData.siteUsers"
          :filled="!isTable"
          :outlined="isTable"
          :dense="isTable"
          :label="isTable ? '' : head.text"
          :placeholder="isTable ? 'Søk...' : ''"
          item-text="name"
          item-value="cp"
          clearable
          :disabled="head.disabled"
          :class="{ 'mb-0': isTable }"
          hide-details="auto"
          menu-props="auto"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <!-- <div class="d-flex justify-start">
              <span v-if="index === 0">{{ item.name }}</span>
              <span v-if="index === 1" class="grey--text text-caption">
                &nbsp;(+{{ head.filterValues.length - 1 }} andre)
              </span>
            </div> -->
            <!-- <div v-if="head.filterValues && head.filterValues.length > 1">
              {{
                head.filterValues && head.filterValues.length === 1
                  ? item.name
                  : index === 1
                  ? `${head.filterValues.length} valgt`
                  : ""
              }}
            </div>
            <div v-else :class="{ 'v-select__selection--disabled': disabled }">
              {{ item.name }}
            </div> -->
            <div
              v-if="typeof head.filterValues === 'object'"
              class="v-select__selection v-select__selection--comma"
            >
              {{
                head.filterValues && head.filterValues.length === 1
                  ? item.name
                  : index === 1
                  ? `${head.filterValues.length} valgt`
                  : ""
              }}
            </div>
            <div
              v-else
              class="v-select__selection v-select__selection--comma"
              :class="{ 'v-select__selection--disabled': disabled }"
            >
              {{ item.name }}
            </div>
          </template>
        </v-autocomplete>
      </template>

      <template v-slot:filter.ourReference="{ head, isTable }">
        <v-autocomplete
          v-if="!head.removeFilter"
          v-model="head.filterValues"
          :items="filterData.users"
          :filled="!isTable"
          :outlined="isTable"
          :dense="isTable"
          :label="isTable ? '' : head.text"
          :placeholder="isTable ? 'Søk...' : ''"
          item-text="name"
          item-value="cp"
          clearable
          :class="{ 'mb-0': isTable }"
          hide-details="auto"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <div
              v-if="typeof head.filterValues === 'object'"
              class="v-select__selection v-select__selection--comma"
            >
              {{
                head.filterValues && head.filterValues.length === 1
                  ? item.name
                  : index === 1
                  ? `${head.filterValues.length} valgt`
                  : ""
              }}
            </div>
            <div v-else class="v-select__selection v-select__selection--comma">
              {{ item.name }}
            </div>
          </template>
        </v-autocomplete>
      </template>

      <template v-slot:filter.project="{ head, isTable }">
        <v-text-field
          v-if="!head.removeFilter"
          :label="isTable ? '' : head.text"
          :value="getProjectName"
          :disabled="head.disabled"
          dense
          filled
          flat
          hide-details="auto"
        >
        </v-text-field>
      </template>
      <template v-slot:filter.phase="{ head, isTable }">
        <v-text-field
          v-if="!head.removeFilter"
          :label="isTable ? '' : head.text"
          :value="getProjectPhase"
          :disabled="head.disabled"
          dense
          filled
          flat
          hide-details="auto"
        >
        </v-text-field>
      </template>
    </OverviewComponent>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { OrderObject } from "@/types/orderInterface";

import projectApi from "@/api/projectApi";
import { HeaderObject } from "@/types/tableInterface";
import OverviewComponent from "@/components/shared/overview/OverviewComponent.vue";

export default Vue.extend({
  data: () => ({
    headers: [] as Array<HeaderObject>,
    data: [] as Array<OrderObject>,
    loading: false,
    search: "",
    maxtText: 10,
    //maxTextmobile: 35,
    maxTitelLength: 12,
    totalPages: 0,
    totalItemCount: -1,
    filterData: { users: [], siteUsers: [] },
    statusItems: [
      { text: "Frigitt", value: "Frigitt" },
      { text: "Ny (ikke sendt)", value: "Ny (ikke sendt)" },
      { text: "Mottatt", value: "Mottatt" },
      { text: "Ukjent", value: "Ukjent" },
    ],
    selectStatus: "Frigitt",
  }),
  async created() {
    await this.getFilterData();
  },
  methods: {
    ...mapActions({
      setShowTable: "tables/setShowTable",
      setShowAll: "tables/setShowAll",
    }),
    async getFilterData() {
      await projectApi
        .getOrdersFilterData()
        .then((response) => {
          this.filterData.users = response.users;
          this.filterData.siteUsers = response.siteUsers;
        })
        .catch();
    },
    async fetchData({ data, bottomOfPage }) {
      // if (!this.showAllActions) {
      //   data.page = 0;
      // }
      this.loading = true;
      var houseId = this.$route.params.houseId;
      await projectApi
        .getProjectHouseOrders(houseId, data)
        .then((response: any) => {
          if (bottomOfPage) {
            this.data = [...this.data, ...response.items];
          } else {
            this.data = response.items;
          }

          this.totalPages = response.totalPages;
          this.totalItemCount = response.totalItemCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goToOrder(orderId) {
      this.$router.push({
        name: "OrderView",
        params: { orderId: orderId },
      });
    },
    clickCard(item) {
      if (this.showTable) return;

      this.$router.push({
        name: "OrderView",
        params: { orderId: item.orderId },
      });
    },
    getTruncatedText(text: string): string {
      text = text.trim();
      return text.length > this.getmaxText
        ? text.substring(0, this.getmaxText) + "..."
        : text;
    },
    getTruncatedTitle(text: string): string {
      //text += "                ";
      text = text.trim();
      return text.length > this.maxTitelLength
        ? text.substring(0, this.maxTitelLength) + "..."
        : text;
    },
    setHeader() {
      this.headers = [
        {
          text: "Prosjekt",
          value: "project",
          type: "string",
          show: false,
          filterClause: 0,
          filterName: "project",
          sortable: false,
          disabled: true,
        },
        {
          text: "Bygg",
          value: "phase",
          type: "string",
          show: false,
          filterClause: 0,
          filterName: "phase",
          sortable: false,
          disabled: true,
        },
        {
          text: "OrderId",
          value: "orderId",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 3,
          filterName: "orderId",
        },
        {
          text: "Status",
          value: "status",
          type: "string",
          show: true,
          filterValues: ["Frigitt"],
          filterClause: 0,
          filterName: "status",
          sortable: false,
        },
        {
          text: "Prosess",
          value: "process",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "process",
          sortable: true,
        },
        {
          text: "Ordredato",
          value: "orderDate",
          type: "date",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "orderDate",
          dateType: "DD.MM.YYYY",
          sortable: true,
        },
        {
          text: "Vår kontakt", //ansvarlig?? nei
          value: "ourReference",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "ourContactPerson",
          sortable: false,
        },
        {
          text: "Leveringsdato",
          value: "deliveryDate",
          type: "date",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "deliveryDate",
          dateType: "DD.MM.YYYY",
          sortable: true,
        },
        {
          text: "Kontaktperson byggeplass", //ansvarlig?? ja
          // value: this.showAllActions
          //   ? "contactPerson"
          //   : this.profile.person.fullName,
          value: "contactPerson",
          type: "string",
          show: true,
          filterValues: this.showAllActions ? "" : this.profile.id,
          filterClause: 0,
          isAssignedTo: true,
          disabled: this.showAllActions ? false : true,
          filterName: "siteContactPerson",
          sortable: false,
        },
        {
          text: "Leveringsadresse",
          value: "deliveryAddress",
          type: "date",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "deliveryAddress",
        },
        {
          text: "Leverandør",
          value: "contactName",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "contactName",
        },
      ];
    },
    getChips(item: any) {
      var data = [
        {
          title: item.allReceived ? "Mottatt" : item.status,
          color: item.allReceived ? "success" : "warning",
        },
        {
          title:
            item.process.length > this.maxtText
              ? this.getTruncatedText(item.process)
              : item.process,
        },
      ];

      return data;
    },
    // async changeShowAll() {
    //   debugger;
    //   this.setHeader();
    //   await this.fetchData({ data: [...this.headers], bottomOfPage: false });
    // },
  },

  computed: {
    ...mapGetters({
      profile: "shared/profile",
      showAll: "tables/showAll",
      showTable: "tables/showTable",
    }),
    showAllOrders(): boolean {
      return this.showAll.value;
    },
    tableId(): string {
      if (this.$route.name) {
        //Make tebleId by route name
        return `BT${this.$route.name}${this.$route.params.houseId}${
          this.showAllOrders ? "All" : ""
        }`;
      }

      return "BTOverview";
    },
    // dataFiltered(): Array<OrderObject> {
    //   if (this.data.length > 0 && !this.showAll?.value) {
    //     return this.data.filter(
    //       (x) =>
    //         x.contactPersonId === this.profile.id &&
    //         (this.search
    //           ? x.orderId.toUpperCase().includes(this.search.toUpperCase())
    //           : true)
    //     );
    //   }
    //   return this.data.filter((x) =>
    //     this.search
    //       ? x.orderId.toUpperCase().includes(this.search.toUpperCase())
    //       : true
    //   );
    // },
    getmaxText(): number {
      if (this.$vuetify.breakpoint.xs) {
        return 27;
      } else if (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md) {
        return 25;
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return 17;
      }
      return this.maxtText;
    },
    showAllActions(): boolean {
      return this.showAll.value;
    },
    getProjectName(): string {
      return this.data[0]?.project;
    },
    getProjectPhase(): string {
      return this.data[0]?.phase;
    },
    getContactPersonName(): string {
      return this.profile.person.fullName;
    },
  },

  components: {
    //BaseHeadline,
    //CaseCardList,
    //Searchbar,
    OverviewComponent,
  },
});
</script>
